"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIGHTBOX_PADDING = void 0;
var LIGHTBOX_PADDING = 70;
exports.LIGHTBOX_PADDING = LIGHTBOX_PADDING;